<template>
  <div>
    <div class="col-mr-5 mt-3">
      <right-panel class="float-right" id="sidebar-new-other-collect-method" width="800px" :icon="'mdi mdi-plus'" :text="$t('other-collect-method.new')">
        <div class="pl-5 pr-5">
          <FormOtherCollectMethod :inventory="true" :hide-library="true" />
        </div>
      </right-panel>
    </div>

    <h6>{{ $t("other-collect-method.text") }}</h6>

    <LibraryItems
      rightPanelId="sidebar-new-datasource-other-collect-method"
      organizationScopedState="datasourceOtherCollectMethod"
      libraryScopedState="otherCollectMethod"
      :hideCategoryFilter="true"
      :hideSaveAs="true"
      @interceptForSetParent="interceptForSetParent"
    />
  </div>
</template>

<script>
import LibraryItems from "@cc/library-items";
import FormOtherCollectMethod from "@modules/collect-method/workspace-library-other-collect-method-form";

export default {
  props: ["hide-library"],
  components: {
    LibraryItems,
    FormOtherCollectMethod,
  },
  data() {
    return {
      form: { name: undefined },
      formError: undefined,
      entityName: undefined,
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourceOtherCollectMethod/isUpdating"];
    },
    //

    editedDatasource() {
      return this.$store.getters["datasourceOtherCollectMethod/editedDatasource"];
    },
  },
  mounted() {},
  methods: {
    cancel() {
      this.$store.dispatch("datasourceOtherCollectMethod/resetForm");
    },

    interceptForSetParent(payload) {
      payload.datasource = this.editedDatasource;
    },
  },
};
</script>
